import { createSelector } from '@reduxjs/toolkit';
import { getIsCertificateCreated } from '../certificate/selectors';
import {
  getOrderIsPaid,
  getPaymentIsProcessing,
} from '../../../../store/payment/selectors';
import type { ViewState } from './slice';
import { name } from './slice';

const viewStateSelf = (state): ViewState => state.get(name);

export const getIsClientConfirmed = createSelector(
  viewStateSelf,
  (state) => state.isClientConfirmed,
);
export const getIsProcessing = createSelector(viewStateSelf, (state) =>
  Boolean(state.isProcessing),
);
export const getIsTyping = createSelector(
  viewStateSelf,
  (state) => state.isTyping,
);

export const getOverlayText = createSelector(
  [
    getIsProcessing,
    getPaymentIsProcessing,
    getIsCertificateCreated,
    getOrderIsPaid,
  ],
  (isProcessing, isPaymentProcessing, isCreated, isPaid) => {
    if (isProcessing) {
      if (!isCreated) {
        return 'Создание заказа...';
      }
      if (isPaymentProcessing || !isPaid) {
        return 'Оплата заказа...';
      }
      return 'Получение сертификата...';
    }
    return null;
  },
);

export const getErrorMessage = createSelector(
  viewStateSelf,
  (state) => state?.error?.message,
);
export const getIsErrorShown = createSelector(
  viewStateSelf,
  (state) => state.isErrorShown,
);
